export default {
  lowercase,
  uppercase,
  datetime,
  number,
  currency,
} as const;

const DEFAULT_LANGUAGE = "en";

export function lowercase(value: string) {
  return value.toLowerCase();
}

export function uppercase(value: string) {
  return value.toUpperCase();
}

function qualifiedLngFor(lng: string): string {
  switch (lng) {
    case "en":
      return "en-GB";
    case "de":
      return "de-DE";
    default:
      return lng;
  }
}

export function datetime(
  value: Date | number,
  lng: string | undefined,
  options?: Intl.DateTimeFormatOptions,
): string {
  return new Intl.DateTimeFormat(
    qualifiedLngFor(lng || DEFAULT_LANGUAGE),
    options,
  ).format(value);
}

export function number(
  value: number,
  lng: string | undefined,
  options?: Intl.NumberFormatOptions,
): string {
  return new Intl.NumberFormat(
    qualifiedLngFor(lng || DEFAULT_LANGUAGE),
    options,
  ).format(value);
}

export function currency(
  value: number,
  lng: string | undefined,
  options?: Intl.NumberFormatOptions,
): string {
  return number(value, lng, {
    style: "currency",
    currency: "EUR",
    ...options,
  });
}
